export const tr = {
    'actions-title': 'İşlem',
    'add-banner': 'Banner ekle',
    'add-group': 'Reklam grubu ekle',
    aim: 'Reklama hedefleme yap',
    bannerAimingDisabledMessage:
        "Hedefleme, moderasyondan geçmiş ve başlatılmış kampanyalar ile banner'lar için çalışır",
    copy: 'Kopyala',
    delete: 'Sil',
    edit: 'Parametreleri düzenle',
    'go-to-report-master': 'Go to Report Wizard',
    'internal-tool-title': 'Dahili araçlar',
    moderate: 'Kontrole gönder',
    moderateAccept: 'Moderasyonu onayla',
    moderateAcceptBannersAdditions: 'Moderasyon: Netleştirmeleri kabul et',
    moderateByClient: 'Kontrole gönder',
    notEditable: 'Düzenleme geçersiz',
    'regions-transform': 'Gösterim bölgelerini ayarla',
    remoderate: 'Yeniden moderasyon',
    remoderateBannersAdditions: 'Netleştirmelerin yeniden moderasyonu',
    resume: 'Etkinleştir',
    sendBK: "Hareketli Banner'a gönder",
    'show-params': 'Parametreleri görüntüle',
    suspend: 'Durdur'
};
